import {
	connect
} from 'react-redux'
import OrderEditComponent from '../components/OrderEditComponent.jsx';
import {
	changeOrderValue,
	addOrder,
	editOrder,
	findAllCustomerIds
} from '../actions';

function showNote(roles) {
	return roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD");
}

const mapStateToProps = (state) => ({
	order: state.getIn(['orderReducer', 'order']),
	orderValidation: state.getIn(['orderReducer', 'orderValidation']),
	alertStyle: state.getIn(['orderReducer', 'alertStyle']),
	alertMessage: state.getIn(['orderReducer', 'alertMessage']),
	forInsert: state.getIn(['orderReducer', 'forInsert']),
	allCustomerIds: state.getIn(['orderReducer', 'allCustomerIds']),

	activePage: state.getIn(['orderListReducer', 'activePage']),
	itemPerPage: state.getIn(['orderListReducer', 'itemPerPage']),
	showNote: showNote(state.getIn(['authReducer', 'roles']).toJS())
})

const mapDispatchToProps = (dispatch) => ({
	editOrder: (order, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(addOrder(order, pagingData));
		} else {
			dispatch(editOrder(order, pagingData));
		}
	},
	setValue: (id, value) => {
		dispatch(changeOrderValue({
			id: id,
			value: value
		}))
	},
	findAllCustomerIds: () => {
		dispatch(findAllCustomerIds());
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	order: stateProps.order,
	orderValidation: stateProps.orderValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	forInsert: stateProps.forInsert,
	allCustomerIds: stateProps.allCustomerIds,
	showNote: stateProps.showNote,
	componentDidMount: dispatchProps.componentDidMount,
	editOrder: () => dispatchProps.editOrder(stateProps.order, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}, stateProps.forInsert),
	setValue: dispatchProps.setValue,
	findAllCustomerIds: dispatchProps.findAllCustomerIds
})

const OrderEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(OrderEditComponent)

export default OrderEditContainer;


// WEBPACK FOOTER //
// ./src/containers/OrderEditContainer.jsx